module.exports = __webpack_public_path__ + "static/media/the-dutch-6.338e8c21.jpg";